import { FC, useEffect, useMemo, useState } from "react"
import { DiaryRow } from "./types"
import { Owner } from "shared/types"
import TagItem from '@atomaro/ui-kit/components/Tag/TagItem/TagItem';
import profileImg from "shared/assets/img/user.png";
import { TableAuthorWrapper } from "./styles";

type DiaryAuthorCellProps = {
  row: DiaryRow
}
export const DiaryAuthorCell: FC<DiaryAuthorCellProps> = ({
  row
}) => {

  const [ author, setAuthor ] = useState<Owner | null>(null);

  useEffect(() => {
    if (row?.author) {
      setAuthor(row?.author)
    }
  }, [row])

  const avatarImage = useMemo(() => {
    const avatarId = row?.author?.profile?.avatar?.id;
    if (!avatarId) {
      return profileImg
    }

    return `/ecpp/attachments/files?attachmentId=${avatarId}`
  }, [row])

  if (!author) return <>-</>

  return (
    <TableAuthorWrapper data-tag="allowRowEvents">
      {author ? 
      <TagItem
        variant="secondary"
      >
        <img src={avatarImage} alt={author.name.first} />
        <span>{author.name.first}</span>
      </TagItem> 
      : '-'}
    </TableAuthorWrapper>
  )
}